<template>
<div>
  <div class="page-header">
          <div class="row justify-content-end">
            <div class="col-10 text-left">
              <h2 class="page-title">{{$t('registration.tabs.tabProfileSummary')}}</h2>
            </div>
            <div class="col-2 lighten text-right">
              <!-- <h2 class="page-title">17%</h2> -->
            </div>
          </div>
        </div>
       <div class="row profileSummary justify-content-center">
        <div class="col-12">
            <div class="card-body">
                <div class="card-content">
                    <div class="row">
                        <div class="col-auto">
                            <img class="userpic img-thumbnail d-block circle" :src="profilesrc">
                        </div>
                        <div class="col align-self-center">
                            <div class="row">
                        <div class="col text-left">
                            <div class="title">{{$t('candidateProfile.profileSummary.lblPersonalDetails')}}</div>
                        </div>
                        <div class="col text-right">
                            <b-link class="btn btn-info-alt" to="personalDetails">{{$t('candidateProfile.profileSummary.btnEditDetails')}}</b-link>
                        </div>
                    </div>
                            <!-- <div class="section">{{$t('candidateProfile.profileSummary.lblName')}}<div class="input-css">{{candidateProfile.personalDetails.fullName}}.</div>  -->
                            <div class="section">{{$t('candidateProfile.profileSummary.lblName')}}<div class="input-css">{{candidateProfile.personalDetails.fullName}}</div> 
                            {{$t('candidateProfile.profileSummary.lblFatherName')}} <div class="input-css">{{candidateProfile.personalDetails.fatherName}}</div>
                            {{$t('candidateProfile.profileSummary.lblAnd')}} 
                            <div class="input-css">{{candidateProfile.personalDetails.motherName}}.</div>
                            {{$t('candidateProfile.profileSummary.lblGender')}} <div class="input-css">{{candidateProfile.personalDetails.gender.name}}.</div>
                            {{$t('candidateProfile.profileSummary.lblDOB')}} <div class="input-css">{{candidateProfile.personalDetails.dob | formatDate }}.</div>
                            {{$t('candidateProfile.profileSummary.lblMotherTounge')}} <div class="input-css">{{candidateProfile.personalDetails.motherTongue.name}}</div> {{$t('candidateProfile.profileSummary.lblAnd')}} 
                            {{$t('candidateProfile.profileSummary.lblMaritalStatus')}} <div class="input-css">{{candidateProfile.personalDetails.maritalStatus.name}}.</div>
                            </div>
                        </div>
                    </div>
                 </div>
            </div>
            <hr/>
            </div>
             <div class="col-12">
                <div class="card-body">
                    <div class="card-content">
                    <div class="row">
                        <div class="col text-left">
                            <div class="title">{{$t('candidateProfile.profileSummary.lblContactDetails')}}</div>
                        </div>  
                        <div class="col text-right">
                            <b-link class="btn btn-info-alt" to="address">{{$t('candidateProfile.profileSummary.btnEditDetails')}}</b-link>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-md-9 col-sm-12"> -->
                            <div class="section">{{$t('candidateProfile.profileSummary.lblMobileNumber')}}<div class="input-css">{{candidateProfile.contactDetails.phoneNo}},</div>
                            {{$t('candidateProfile.profileSummary.lblEmailID')}} <div class="input-css">{{candidateProfile.contactDetails.email}}.</div>
                            {{$t('candidateProfile.profileSummary.lblCorrespondanceAddress')}} <div class="input-css">{{candidateProfile.contactDetails.corespondeneceAddress.tehsil}}, {{candidateProfile.contactDetails.corespondeneceAddress.district}}, {{candidateProfile.contactDetails.corespondeneceAddress.state}}.</div>
                            {{$t('candidateProfile.profileSummary.lblPermanentAddress')}} <div class="input-css">{{candidateProfile.contactDetails.permanentAddress.tehsil}}, {{candidateProfile.contactDetails.permanentAddress.district}}, {{candidateProfile.contactDetails.permanentAddress.state}}</div>
                            {{$t('candidateProfile.profileSummary.lblRespectively')}} <div v-if="candidateProfile.contactDetails.skypeId !== ''">{{$t('candidateProfile.profileSummary.lblSkypeId')}} <div class="input-css">{{candidateProfile.contactDetails.skypeId}} .</div></div>
                            </div>
                    </div>
                </div>
                 <hr/>
            </div>
            <div class="col-12" v-if="screenConfig.visible">
                <div class="card-body">
                    <div class="card-content">
                    <div class="row">
                        <div class="col text-left">
                            <div class="title"> {{$t('candidateProfile.profileSummary.lblITCertification')}}</div>
                        </div>  
                        <div class="col text-right">
                            <b-link class="btn btn-info-alt" to="itCertification">{{$t('candidateProfile.profileSummary.btnEditDetails')}}</b-link>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-md-9 col-sm-12"> -->
                            <div class="section" v-if="candidateProfile.itCertificationsDetails.itCertification.certificationID !== 0">{{$t('candidateProfile.profileSummary.lblCompletedITCertification')}}  <div class="input-css">{{candidateProfile.itCertificationsDetails.itCertification.certificationName}}.</div>
                            {{$t('candidateProfile.profileSummary.lblLearnerCode')}} <div class="input-css">{{candidateProfile.itCertificationsDetails.learnerCode}}.</div>
                            <div v-if="candidateProfile.knownLanguages.length > 0 ">{{$t('candidateProfile.profileSummary.lblSkil')}} <div class="input-css">{{candidateProfile.itCertificationsDetails.knownLanguagesInfo}}</div> {{$t('candidateProfile.profileSummary.lblITCertficationTechnology')}} </div>
                            <div v-if="candidateProfile.experienceDetails.length > 0">{{$t('candidateProfile.profileSummary.lblPreviousExperience')}} <div class="input-css">{{candidateProfile.itCertificationsDetails.experienceDetails}}.</div></div>
                            </div>
                            <div class="section" v-if="candidateProfile.itCertificationsDetails.itCertification.certificationID === 0">{{$t('candidateProfile.profileSummary.lblCertificationNotCompleted')}}
                            </div>
                            <div class="section">
                            <div v-if="candidateProfile.itCertificationsDetails.referralCode">{{$t('candidateProfile.profileSummary.lblReferalCode')}} <div class="input-css">{{candidateProfile.itCertificationsDetails.referralCode}}.</div></div>
                            <div v-if="candidateProfile.itCertificationsDetails.alcCode">{{$t('candidateProfile.profileSummary.lblAlcCode')}} <div class="input-css">{{candidateProfile.itCertificationsDetails.alcCode}}.</div></div>
                            </div>
                    </div>
                </div>
                 <hr/>
            </div>
               
        
        <div class="col-12">
            <div class="card-body">
                    <div class="card-content">
                        <div class="row justify-content-end">
                            <div class="col align-self-start">
                            <div class="title">{{$t('candidateProfile.profileSummary.lblEducationDetails')}} </div>
                            </div>
                            <div class="col align-self-start text-right">
                            <b-link class="btn btn-info-alt" to="educationalDetails">{{$t('candidateProfile.profileSummary.btnEditDetails')}}</b-link>
                            </div>
                        </div>
                            <div class="details">
                                <div class="row">
                                    <div class="col-4" v-if="candidateProfile.educationDetails.isSSCPassed">
                                        <div>{{$t('candidateProfile.profileSummary.lblSSC')}}<img class="dpic documentImg img-fluid img-thumbnail" :src="sscsrc" @click="showSSC = true"></div>
                                    </div>
                                    <div class="col-4" v-if="candidateProfile.educationDetails.isHSCPassed">     
                                        <div>{{$t('candidateProfile.profileSummary.lblHSC')}}<img class="dpic documentImg img-fluid img-thumbnail" :src="hscsrc" @click="showHSC = true"></div>
                                    </div>
                                    <div class="col-4" v-if="candidateProfile.educationDetails.isDiplomaPassed">
                                        <div>{{$t('candidateProfile.profileSummary.lblDiploma')}}<img class="dpic documentImg img-fluid img-thumbnail" :src="diplomasrc" @click="showDiploma = true"></div>
                                    </div>
                                    <div class="col-12" v-if="candidateProfile.educationDetails.neverAppeared">
                                        <b class="red">{{$t('candidateProfile.profileSummary.lblNotEligible')}} </b>
                                    </div>
                                 </div>
                             </div>
                    </div>
            </div>
        </div>
 
         <div class="col-md-12 text-center p-4">
           <div class="row">
        <button type="button" class="btn btn btn-info-alt mr-3" @click="prevTabFunc"> {{$t('button.back')}}</button>
        <button type="button" class="btn btn btn-orange ml-auto" @click="nextTabFunc"> {{$t('button.confirm_proceed')}}</button>
   </div>
    </div>
       
    </div>
    <modal class="lg" v-if="showSSC" @close="showSSC = false">   
          <h3 slot="header">SSC Document</h3>
          <div slot="body">
           <img :src="sscsrc"  width="100%">
           </div>
       
    </modal>
      <modal class="lg" v-if="showHSC" @close="showHSC = false">   
          <h3 slot="header">HSC Document</h3>
          <div slot="body">
           <img :src="hscsrc" width="100%">
           </div>
           
    </modal>
      <modal class="lg" v-if="showDiploma" @close="showDiploma = false">   
          <h3 slot="header">DIploma Document</h3>
          <div slot="body">
           <img :src="diplomasrc"  width="100%">
           </div>
      
    </modal>
</div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import modal from '@/components/common/modal.vue'
import candidateProfile from '../../store/modules/candidateProfile'
axios.default.baseURL = ''
export default {
  name: 'profileSummary',
  components: {modal, candidateProfile: candidateProfile},
  data () {
    return {
      candidateProfile: {
        personalDetails: {
          gender: { },
          maritalStatus: { },
          motherTongue: { }
        },
        contactDetails: { permanentAddress: {}, corespondeneceAddress: {} },
        documents: [ ],
        educationDetails: { },
        experienceDetails: [ ],
        hobbies: [ ],
        knownLanguages: [ ],
        knownTechnologies: [ ],
        itCertificationsDetails: {
          itCertification: { }
        }
      },
      profilesrc: '',
      sscsrc: '',
      hscsrc: '',
      diplomasrc: '',
      corespondenceAddress: { },
      permanentAddress: { },
      address: { },
      correspondanceSameAspermananent: false,
      showSSC: false,
      showHSC: false,
      showDiploma: false,
      screenConfig: {}
    }
  },
  methods: {
    nextTabFunc () {
      var self = this
      if (this.candidateProfile.profileStatus.itCertificationsDetails && this.candidateProfile.profileStatus.personalDetails && this.candidateProfile.profileStatus.contactDetails && this.candidateProfile.profileStatus.educationDetails && this.candidateProfile.profileStatus.documentDetails && this.candidateProfile.profileStatus.qualificationDetails) {
        axios.post('r/candidateProfile/confirmProfile/' + this.$store.state.candidateProfile.profileUser)
          .then(response => {
            if (response.status === 200) {
              this.$toasted.success(self.$t('toastr.toastrProfileCompleted'))
              this.$store.commit('STORE_CONFIRM_STATUS', true)
              this.$router.push({ name: 'candidateApplication' })
            }
          })
          .catch(e => {
            console.log(e)
          })
      } else {
        this.$toasted.error(self.$t('candidateProfile.profileSummary.toastrFillAllSections'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        })
      }
    },
    prevTabFunc () {
      axios.get('r/projectConfig/getAllProjectConfig')
      .then(responses => {
        if (responses.data.ocrConfig.required) {
          this.$router.push({ name: 'imageExtracter' })
        } else {
          this.$router.push({ name: 'qualificationDetails' })
        }
      })
      .catch(e => {
        console.log(e)
      })
    },
    getCompleteCandidateProfile: function () {
      var self = this
      var profileUser = this.$store.state.candidateProfile.profileUser
      return axios.get('/r/candidateProfile/getCompleteCandiateProfile/' + profileUser).then(response => {
        if (response.data !== null) {
          this.candidateProfile = response.data
          if (this.candidateProfile.contactDetails.corespondenecePin != null && this.candidateProfile.contactDetails.permanentPin) {
            if (this.candidateProfile.contactDetails.corespondenecePin === this.candidateProfile.contactDetails.permanentPin) {
              this.correspondanceSameAspermananent = true
              // this.getCompleteAddress(this.candidateProfile.contactDetails.corespondenecePin)
              this.getDocuments()
            } else {
              this.correspondanceSameAspermananent = false
              // this.getCompleteAddress(this.candidateProfile.contactDetails.corespondenecePin)
              // this.getCompleteAddress(this.candidateProfile.contactDetails.permanentPin)
              this.getDocuments()
            }
          }
        }
        return true
      }).catch(e => {
        this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        })
        console.error(e)
        return false
      })
    },
    getCompleteAddress: function (pincode) {
      var self = this
      axios.get('/r/candidateProfile/getCompleteAddressOfPincode/' + pincode).then(response => {
        if (response.data !== null) {
          if (response.data === 'false') {
            this.$toasted.info(self.$t('candidateProfile.profileSummary.toastrPinCodeNotFound'), {
              theme: 'bubble',
              duration: this.TOASTR_TIME
            })
          } else {
            if (this.correspondanceSameAspermananent === true) {
              this.corespondenceAddress = response.data
              this.permanentAddress = this.corespondenceAddress
            } else if (this.candidateProfile.contactDetails.corespondenecePin === pincode) {
              this.corespondenceAddress = response.data
            } else {
              this.permanentAddress = response.data
            }
          }
        } else {
          this.$toasted.error(self.$t('candidateProfile.profileSummary.toastrPinCodeNotFound'), {
            theme: 'bubble',
            duration: this.TOASTR_TIME
          })
        }
      }).catch(e => {
        this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        })
        console.error(e)
      })
    },
    changeTab: function (oldIndex, newIndex) {
      this.$emit('nextTab', oldIndex, newIndex)
    },
    getDocuments () {
      var doc = this
      var profileUser = this.$store.state.candidateProfile.profileUser
      let myarray = doc.candidateProfile.documents
      myarray.forEach(element => {
        if (element.docId === (profileUser + '_ProfilePicture')) {
          doc.profilesrc = element.docImage
        } else if (element.docId === (profileUser + '_SSC')) {
          doc.sscsrc = element.docImage
        } else if (element.docId === (profileUser + '_HSC')) {
          doc.hscsrc = element.docImage
        } else if (element.docId === (profileUser + '_Diploma')) {
          doc.diplomasrc = element.docImage
        } else {
        }
      })
    },
    getProjectConfig () {
      axios.get('o/screenConfig/getScreenConfigByID/' + 'IT_CERTIFICATION').then(response => {
        this.screenConfig = response.data
      }).catch(function (e) {
        console.error(e)
      })
    }
  },
  created: function () {
    if (this.$store.state.user.userDetails.confirmStatus) {
      this.$router.push({ name: 'entry' })
    } else {
      this.getProjectConfig()
      this.getCompleteCandidateProfile()
    }
  },
  filters: {
    formatDate (value) {
      if (value) {
        return moment(String(value)).format('DD-MMM-YYYY')
      }
    }
  }
}
</script>
<style lang="scss">
.profileSummary{
    .page-header{
        padding-bottom:30px;
    }
    .card-body{
         padding:0px;
        .card-content{
            margin-top:10px;
            margin-bottom:20px;
            .title{ font-weight: 500; font-size:18px; color:lighten(#495057,20%); display:block;}
            .section{padding-top:15px; div{line-height: 30px;}}
            .input-css{
                display: inline-block;
                font-weight:500;
                // padding-left:12px; padding-right:12px;
                // border-bottom: 1px solid #ddd;
                font-size:18px; 
                color:darken(#495057,10%);
            }
            // min-height:0px;
            transition: all 0.2s;
            // h5{padding-bottom:10px;}
            // margin-top:40px;
            // border:1px solid #eee;
            // background-color:#f9f9f9;
            padding:30px;
            // border-radius: 5px;
            // background: #fff; transition: 300ms ease; transition: 300ms ease; position: relative;
                &:hover {
                    // box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.18); 
                    .btn-danger-alt{
                        background-color:#ff4949;
                    }
                }
                hr{border-color:transparent;}
                .userpic{
                    border-radius: 50%;
                    width:120px;
                    height:120px;
                    object-fit: fill;
                }
                .dpic{border-radius:5px; display: block; width:100%; height: 240px; margin-top:10px;}
                .pad-b{padding-bottom:20px;}
                .details{
                    font-size:14px;
                        // padding-bottom:30px;
                    span{
                        .mdi{padding-right:5px;}
                        padding-right:10px;
                    }
                    .inline{
                        display: inline-block;
                        padding-right:30px;
                        padding-bottom:15px;
                        span{text-transform: uppercase; font-weight:600; color:lighten(#37474f,1%); font-size:12px;}
                    }
                    .block{
                        display: block;
                        padding-right:30px;
                        padding-bottom:15px;
                        span{text-transform: uppercase; font-weight:600; color:lighten(#37474f,1%); font-size:12px;}
                    }
                }
                .btn-info-alt{
                    padding:10px 20px; font-size:11px;
                    background-color: #999;
                    border:none;
                    &:hover{box-shadow:none; background-color:darken(#4885ed,3%); }
                }
            }
  }
}
.dpic{
    transition: all .2s ease-in;
    cursor: pointer;
  }
  .dpic:hover{
    transform: scale(1.1);
    border: 2px solid #ccc;
  }
</style>




// WEBPACK FOOTER //
// src/components/registration/profileSummary.vue